document.addEventListener('DOMContentLoaded', () => {
	const sliderContainer = document.querySelector('.slider-container');
	if (sliderContainer) {
		let IbSlideIndex = 0;
		const IbSlides = document.querySelectorAll('.slider-container .slide');
		const IbThumbnails = document.querySelectorAll('.slider-container .thumbnail');

		// Function to show or hide slides based on IbSlideIndex
		const updateSlides = () => {
			IbSlides.forEach((slide, index) => {
				const currentSlide = slide; // Create a new variable
				currentSlide.style.display = index === IbSlideIndex ? 'block' : 'none';
			});

			IbThumbnails.forEach((thumbnail, index) => {
				thumbnail.classList.toggle('active', index === IbSlideIndex);
			});
		};

		// Show the initial slide
		updateSlides();

		// Event listener for the slider navigation arrows
		sliderContainer.addEventListener('click', event => {
			if (event.target.classList.contains('prev')) {
				IbSlideIndex = (IbSlideIndex - 1 + IbSlides.length) % IbSlides.length;
			} else if (event.target.classList.contains('next')) {
				IbSlideIndex = (IbSlideIndex + 1) % IbSlides.length;
			}
			updateSlides();
		});

		// Event listener for the thumbnail navigation
		const thumbnailContainer = document.querySelector('.slider-container .thumbnail-container');
		if (thumbnailContainer) {
			thumbnailContainer.addEventListener('click', event => {
				const clickedThumbnail = event.target.closest('.thumbnail');
				if (clickedThumbnail) {
					IbSlideIndex = Array.from(IbThumbnails).indexOf(clickedThumbnail);
					updateSlides();
				}
			});
		}
	}
});
